import React from 'react';
import {useSelector} from "react-redux";
import {get} from 'lodash';

export default function ({user_level_data}) {
    const me = useSelector(state => state.me);

    const avatar_class = get(me, 'avatar', '');
    const fname = get(me, 'fname', '');
    const lname = get(me, 'lname', '');

    return (
        <div className="ssp-profile ssp-section">
            <div className="flex-row flex-gap-20">
                <div className="ssp-profile-avatar flex-row flex-vh-center">
                    <div className={`cashtivity-icon ${avatar_class}`}/>
                </div>

                <div className="flex-auto">
                    <div className="ssp-profile-name">
                        {fname} {lname}
                    </div>
                    <div className="flex-row">
                        <div>{`Future Explorer`}</div>
                        <div>&nbsp; &#8226; &nbsp;</div>
                        <div className="ssp-skill-level-name">{`Level `}{user_level_data.level}</div>
                    </div>
                    <div className="ssp-profile-progress">
                        <div className="flex-row flex-between">
                            <div></div>
                            <div className="ssp-profile-xp">
                                {user_level_data.remain_xp}{`/1000 XP`}
                            </div>
                        </div>
                        <div className="ssp-profile-bar">
                            <div className="ssp-profile-bar-solid" style={{width: user_level_data.xp_percentage + '%'}}></div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="ssp-profile-leveltag flex-row flex-vh-center">
                <span>{`LVL ${user_level_data.level}`}</span>
            </div>
        </div>
    );
}